import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

@Component({
  selector: 'pnkl-tab-selector',
  templateUrl: './tab-selector.component.html',
  styleUrls: ['./tab-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabSelectorComponent {
  private _tabList: string[];
  selectedItem: string;
  readonly itemSelected = output<string>();

  get tabList(): string[] {
    return this._tabList;
  }

  @Input() set tabList(list: string[]) {
    this.selectFirstTab(list);
    this._tabList = list;
  }

  itemSelectionHandler(item: string): void {
    this.selectedItem = item;
    this.itemSelected.emit(item);
  }

  private selectFirstTab(list: string[]): void {
    this.selectedItem = list[0];
  }
}
